import { useCallback } from 'react';

import { FILTERS_NAMES } from '@src/constants/filters';
import {
  useSelectFullDealCalculator,
  useUpdateCalculatorEffect,
  useUpdateFullDealCalculator,
} from 'entities/FullDeal/model';

interface Props {
  onChange?: (key: FILTERS_NAMES, value: number) => void;
  /**
   * флаг который позкаыват будет ли обновляться витрина при обновлении ползунков калькулятора
   * 1. Обновление оферов
   * 2. Обновление квери параметров
   */
  isEnabledUpdate?: boolean;
}

export const useOnChangeCalculator = ({ onChange, isEnabledUpdate }: Props) => {
  const { amount, term } = useSelectFullDealCalculator();
  const updateCalculator = useUpdateFullDealCalculator();

  const handleChange = useCallback(
    (key: FILTERS_NAMES, value: number) => {
      onChange?.(key, value);
      if (key === FILTERS_NAMES.AMOUNT) {
        updateCalculator({
          [FILTERS_NAMES.AMOUNT]: value,
          isDirty: true,
        });
      }

      if (key === FILTERS_NAMES.TERM) {
        updateCalculator({
          [FILTERS_NAMES.TERM]: value,
          isDirty: true,
        });
      }
    },
    [onChange, updateCalculator],
  );

  useUpdateCalculatorEffect(isEnabledUpdate);

  return {
    amount,
    term,
    handleChange,
  };
};
